module.exports = __webpack_public_path__ + "img/logo-cacao-white.47dbc341.webp";